import { useTranslation } from "react-i18next";
import { getEasterTiming } from "../utils/easterUtils";

const TIMING_META = {
  before: {
    symbol: "🥚",
    key: "children.common.born_before_easter",
    fallback: "Born before Easter",
  },
  after: {
    symbol: "🐣",
    key: "children.common.born_after_easter",
    fallback: "Born after Easter",
  },
  on: {
    symbol: "🐰",
    key: "children.common.born_on_easter",
    fallback: "Born on Easter",
  },
};

export default function EasterTimingIndicator({ dateBirth }) {
  const { t } = useTranslation();
  const timing = getEasterTiming(dateBirth);
  const meta = timing ? TIMING_META[timing] : null;
  if (!meta) return null;

  const label = t(meta.key, { defaultValue: meta.fallback });
  return (
    <span className="group/easter relative inline-flex" tabIndex={0} aria-label={label}>
      <span aria-hidden="true">{meta.symbol}</span>
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 hidden w-max max-w-52 -translate-x-1/2 rounded-lg bg-slate-950 px-3 py-2 text-center text-xs font-semibold text-white shadow-lg group-hover/easter:block group-focus/easter:block dark:bg-white dark:text-slate-950"
      >
        {label}
      </span>
    </span>
  );
}
